// extracted by mini-css-extract-plugin
export default {"post":"Post_post__MnBnN","delete":"Post_delete__ZoNlD","linkPost":"Post_linkPost__bXHpf"};